import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ErrorService } from '../../../../core/services/error.service';
import { CertificateErrorModalComponent } from '../../../../shared/components/modals/certificate-error/certificate-modal-error.component';
import { CertificateModalSignatureData } from '../../../../shared/services/signature-nca-common-utils.service';
import { ModalService } from '../../../../core/modal/modal.service';

@Component({
  selector: 'tax-eds-content',
  templateUrl: 'eds-content.component.html',
  styleUrls: ['eds-content.component.sass'],
})

export class EdsContentComponent implements OnInit, OnDestroy {
  // @ts-ignore
  @Input() data: CertificateModalSignatureData;

  @Output() signatureGenerated: EventEmitter<CertificateModalSignatureData> = new EventEmitter<CertificateModalSignatureData>();

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private errorService: ErrorService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.errorService.errorType$
      .pipe(
        filter(error => !!error),
        takeUntil(this.destroy$),
      )
      .subscribe((error) => {
        this.modalService.openOld(CertificateErrorModalComponent, {
          message: error,
        });
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
